<app-loading-spinner *ngIf="isLoading" />


<div *ngIf="!isLoading"
    class="flex flex-row items-center gap-6 font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-white cursor-pointer">
    <p class=" " (click)="navigateToCenters()">Centres</p>
    <p class="" onclick="history.back()">Centre Dashboard</p>
    <p class="">View Price List</p>
</div>

<div *ngIf="!isLoading" class="w-full overflow-x-auto px-10 py-7 bg-tileLight shadow-lg rounded-lg dark:bg-[#363636]">
    <div class="flex flex-row items-center justify-between min-w-max">
        <div class="h-[100px]"> <!-- Set a fixed height to prevent layout shifts -->
            <ng-container>
                <p class="font-semibold text-black text-base dark:text-white">
                    Centre: {{ centerName }}
                </p>
                <p class="font-semibold text-black text-base dark:text-white">
                    Market price on {{ today | date: 'yyyy/MM/dd' }}
                </p>
                <p *ngIf="hasData" class="font-semibol text-[#636D81] text-sm mt-1 dark:text-textDark">
                    Last upload at {{ priceListArr[0].createdAt | date: 'hh:mm a' }} on {{ priceListArr[0].createdAt |
                    date: 'yyyy/MM/dd' }}
                </p>
            </ng-container>
        </div>
        <div class="flex flex-row items-center gap-5 ">
            <i class="fa-solid fa-list text-[#4A4A4A] text-lg dark:text-white ml-5"></i>

            <p class="text-[#4A4A4A] dark:text-white">Filter By</p>

            <div class="relative w-28 custom-grade-dropdown-container">
                <!-- Hidden native select -->
                <select [(ngModel)]="selectGrade" class="hidden" (change)="filterGrade()">
                    <option value="" selected disabled>Status</option>
                    <option value="A" class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300">A
                    </option>
                    <option value="B" class="text-textLight dark:text-textDark hover:bg-gray-300">B</option>
                    <option value="C" class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300">C
                    </option>
                </select>

                <!-- Custom dropdown trigger -->
                <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                    (click)="togglegradeDropdown()">
                    <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                        <span>{{ selectGrade || 'Grade' }}</span>
                        <div class="flex items-center">
                            <i *ngIf="selectGrade" (click)="cancelGrade($event)"
                                class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>
                            <i *ngIf="isGradeDropdownOpen || !selectGrade"
                                class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                [class.fa-angle-down]="!isGradeDropdownOpen"
                                [class.fa-angle-up]="isGradeDropdownOpen"></i>
                        </div>
                    </div>
                </div>

                <!-- Custom dropdown options -->
                <div *ngIf="isGradeDropdownOpen"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                    <div *ngFor="let option of gradeDropdownOptions; let first = first; let last = last"
                        (click)="selectGradeOption(option)"
                        class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                        [class.rounded-t-xl]="first" [class.rounded-b-xl]="last">
                        <span class="flex-grow">{{ option }}</span>
                    </div>
                </div>
            </div>


            <div class="flex items-center rounded-full mr-5 px-4 py-2 w-80 bg-[#F1F1F1] dark:bg-[#292929]">
                <input type="text" placeholder="Search by Crop / Variety name.." [(ngModel)]="searchText"
                    class="bg-transparent outline-none w-full text-textLight dark:text-textDark"
                    (keydown.esc)="offSearch()" (keydown.enter)="onSearch()" />
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                    (click)="onSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                    </svg>
                </button>
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="offSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

        </div>

    </div>

    <div *ngIf="!hasData && isMarketPricerExists"
        class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] dark:text-textDark mt-6">
        <p class="text-[#494949] my-6 dark:text-textDark">--No Data Availabale--</p>
        <img src="assets/images/NoData2.png" alt="No Data" class="w-20 h-20 dark:text-textDark" />
    </div>

    <div *ngIf="!hasData && !isMarketPricerExists"
        class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] dark:text-textDark mt-6">
        <p class="text-[#494949] mt-6 dark:text-textDark">Currently, the market price for this centre has not been
            uploaded.</p>
        <p class="text-[#494949] mt-1 mb-6 dark:text-textDark">Please wait!!</p>
        <div #lottieContainer class="w-20 h-20"></div>
    </div>


    <div *ngIf="hasData"
        class=" min-w-max overflow-hidden mt-8 mr-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
        <table class="w-full min-w-max divide-y-2 overflow-hidden">
            <thead class=" text-[#000000] text-base dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021]">
                <tr>
                    <th class="px-6 py-3 text-left text-[#000000] dark:text-[#C5C5C5] text-base font-medium">No</th>
                    <th class="px-6 py-3 text-left text-[#000000] dark:text-[#C5C5C5] text-base font-medium">Crop Name
                    </th>
                    <th class="px-6 py-3 text-left text-[#000000] dark:text-[#C5C5C5] text-base font-medium">Variety
                        Name</th>
                    <th class="px-8 py-3  text-center text-[#000000] dark:text-[#C5C5C5] text-base font-medium">Grade
                    </th>
                    <th
                        class="px-6 w-44 py-3  text-left text-[#000000] dark:text-[#C5C5C5] text-base font-medium whitespace-nowrap">
                        Average Price (Rs.)</th>
                    <th class="px-6 py-3  text-center text-[#000000] dark:text-[#C5C5C5] text-base font-medium">Price
                        (Rs.)</th>

                </tr>
            </thead>
            <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                <tr
                    *ngFor="let item of priceListArr | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems }; let i = index">
                    <td class="px-6 py-3 text-[#000000] text-base dark:text-[#C5C5C5]">
                        {{
                        ((page - 1) * itemsPerPage + i + 1) < 10 ? '0' + ((page - 1) * itemsPerPage + i + 1) : ((page -
                            1) * itemsPerPage + i + 1) }} </td>
                    <td class="px-6 py-3 text-[#000000] text-base dark:text-[#C5C5C5]">{{ item.cropNameEnglish }}</td>
                    <td class="px-6 py-3 text-[#000000] text-base dark:text-[#C5C5C5]">{{ item.varietyNameEnglish }}
                    </td>
                    <td class="px-8 py-3 text-center text-[#000000] text-base dark:text-[#C5C5C5]">{{ item.grade }}</td>
                    <td class="pl-6 w-44 py-3 text-[#000000] text-base dark:text-[#C5C5C5]">{{ item.averagePrice |
                        number:
                        '1.2-2' }}</td>
                    <td class="px-6 py-3 text-center text-[#000000] text-base dark:text-[#C5C5C5]">{{ item.updatedPrice
                        | number:
                        '1.2-2' }}</td>

                </tr>
            </tbody>

        </table>
    </div>
    <div *ngIf="hasData" class="flex justify-end items-center my-5 mr-5 pt-3 dark:bg-[#1D1D1F] text-right">
        <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true" [previousLabel]="'Previous'"
            [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'" [screenReaderPageLabel]="'page'"
            [screenReaderCurrentLabel]="'Youre on page'">
        </pagination-controls>
    </div>
</div>